import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Supplier/constants'
import { Invoice, InvoiceFilterFields, InvoiceMainSearchFields } from 'Portals/Supplier/entities'
import i18n from 'Portals/Supplier/utils/i18nService'

export const getMainSearchConfig = (): Invoice.Search.Config => ({
	[InvoiceMainSearchFields.supplierInvoiceNumber]: {
		label: i18n.t('pages:invoice.filters.supplierInvoiceNumber'),
		apiFieldName: InvoiceMainSearchFields.supplierInvoiceNumber,
		apiSearchFieldName: 'supplierInvoiceNumber',
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.supplierInvoiceNumber
	}
})

export const getFilterConfig = (): Invoice.Filter.Config => ({
	[InvoiceFilterFields.startInvoiceDate]: {
		label: i18n.t('pages:invoice.filters.startInvoiceDate'),
		apiFilterFieldName: InvoiceFilterFields.startInvoiceDate,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[InvoiceFilterFields.endInvoiceDate]: {
		label: i18n.t('pages:invoice.filters.endInvoiceDate'),
		apiFilterFieldName: InvoiceFilterFields.endInvoiceDate,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[InvoiceFilterFields.supplierLocationId]: {
		label: i18n.t('pages:invoice.filters.supplierLocationId'),
		apiFilterFieldName: InvoiceFilterFields.supplierLocationId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.supplierLocationId,
		defaultValue: ''
	},
	[InvoiceFilterFields.status]: {
		label: i18n.t('pages:invoice.filters.status'),
		apiFilterFieldName: InvoiceFilterFields.status,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.status,
		defaultValue: ''
	}
})
